/**
 * Redis Stream Error Type
 *
 * Client-safe error type for Redis stream operations.
 *
 * @since 1.0.0
 */

import { Schema } from "effect";

/**
 * Redis stream error
 * @since 1.0.0
 */
export class RedisStreamError extends Schema.TaggedError<RedisStreamError>()(
  "RedisStreamError",
  {
    message: Schema.String,
    operation: Schema.String,
    cause: Schema.optional(Schema.Unknown),
  },
) {}
